/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 各端支持的支付方式
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PaymentWaysParams {
  constructor(
    public orderId: string,
    public orderType:
      | "RECHARGE"
      | "SHOW"
      | "COMMODITY"
      | "VIDEO"
      | "ACTIVITYAPPLY"
      | "MOVIE",
    public wx: boolean
  ) {}
}

export default async function (
  params: PaymentWaysParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<payment.PaymentWayDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/ways`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
